import client from "./Client";

const getPortalPaymentStatus = (session_id, term_id, type, schoolId) => {
  const params = {};
  if (type) {
    params.type = type;
  }
  if (session_id) {
    params.session_id = session_id;
  }
  if (term_id) {
    params.term_id = term_id;
  }
  return client.get(`/school/${schoolId}/verify-payment`, {
    params,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export default {
  getPortalPaymentStatus,
};
